import React, { useState, useMemo } from 'react';
import EArchiveGroupActionsWrapper from '../EArchiveGroupActionsWrapper';
import { GroupActionItem } from '../../../../Interfaces/GroupActionItem.interface';
import ActionCenterNewMessageModal from '../../../../../ActionCenter/Components/ActionCenterNewMessage/ActionCenterNewMessageModal';
import { useGroupQuery } from '../../../../../../graphql/graphql';

interface Props {
	groupId: string;
}

const EArchiveGroupCentrumActions = ({ groupId }: Props) => {
	const [isNewMessageModalOpen, setIsNewMessageModalOpen] = useState(false);

	const { data } = useGroupQuery({ id: groupId });
	const groupName = data?.group?.name;

	const newMessageDefaultData = useMemo(
		() => ({
			recipients: groupName
				? [
						{
							label: groupName,
							type: 'group',
							value: groupId,
						},
				  ]
				: [],
		}),
		[groupId, groupName],
	);

	const items: GroupActionItem[] = [
		{
			title: 'component.eArchive.group.actions.createNewMessage',
			onClick: () => setIsNewMessageModalOpen(true),
		},
	];

	return (
		<>
			<EArchiveGroupActionsWrapper items={items} />
			{isNewMessageModalOpen && (
				<ActionCenterNewMessageModal
					isOpen
					onClose={() => setIsNewMessageModalOpen(false)}
					defaultData={newMessageDefaultData}
				/>
			)}
		</>
	);
};

export default EArchiveGroupCentrumActions;
